// eslint-disable-next-line import/prefer-default-export
export function hasMultipleCommunities(communities) {
  const collections = communities.filter((community) => community.communityRID !== 'all');
  return collections.length > 1;
}
